import Helper from './Helper';

class Header {
  constructor() {
    this.mainMenu = document.querySelector('#main-menu');
    this.dropdown = document.querySelector('#js-header-dropdown'); 
    this.subMenu = document.querySelector('#js-header-dropdown .header-dropdown__inner');
    this.closeButton = document.querySelector('#js-close-header-dropdown');
    this.mainMenuTogglers = Array.prototype.slice.call(document.querySelectorAll('.js-nav-dropdown-toggler'));
    this.lastClick = false;
    this.burger = document.querySelector('#js-burger');
    this.navCloser = document.querySelector('#js-nav-closer');
    this.headerMobile = document.querySelector('.header__right');
    this.mainNavigation = document.querySelector('.header__navigation');
    this.metaNavigation = document.querySelector('.header__meta');
    this.headerLogo = document.querySelector('.header__left');
    this.bindEvents();
  }

  bindEvents(){
    this.mainMenuTogglers.forEach(toggler => {
      toggler.addEventListener('click', e => {
        e.preventDefault();

        if(Helper.isDesktop()){
          if(this.lastClick != toggler || !this.dropdown.classList.contains('open')){
            this.openMenu(toggler);
          } else{
            this.closeMenu();
          }
          this.lastClick = toggler;
        } else{
          this.mainMenuTogglers.forEach(togglerToClose => {
            if ( togglerToClose != toggler ) {
              Helper.removeClass(togglerToClose, 'open');
            }
          });
          Helper.toggleClass(toggler, 'open');
          this.addMobileBottomPadding();
        }
      });
    });

    this.closeButton.addEventListener('click', () => {
      this.closeMenu();
    });

    this.navCloser.addEventListener('click', () => {
      this.closeMenu();
    });

    this.burger.addEventListener('click', () => {
      Helper.slideToggle(this.headerMobile);

      // calc max height for scrollable mobile navigation
      let headerHeight = 0;
      if ( this.headerLogo.clientHeight >= this.burger.clientHeight ) {
        headerHeight = this.headerLogo.clientHeight;
      } else {
        headerHeight = this.burger.clientHeight;
      }
      let headerElementsHeight = 20 + headerHeight + this.metaNavigation.clientHeight;
      this.mainNavigation.style.maxHeight = "calc(100vh - " + headerElementsHeight + "px)";
    });

  }
  
  openMenu(toggler){
    if(!this.dropdown.classList.contains('open')){
      this.dropdown.classList.add('open');
      this.navCloser.classList.add('active');
    }
    const copy = toggler.parentNode.querySelector('ul');
    this.subMenu.innerHTML = copy.innerHTML;
    this.subMenu.style.width = (this.mainMenu.clientWidth - 15) + 'px';
    
  }
  
  closeMenu(){
    if(this.dropdown.classList.contains('open')){
      this.dropdown.classList.remove('open');
      this.navCloser.classList.remove('active');
    }
  }

  addMobileBottomPadding() {
    if ( this.mainMenu.clientHeight > this.mainNavigation.clientHeight ) {
      this.mainMenu.style.paddingBottom = "80px";
    } else {
      this.mainMenu.style.paddingBottom = null;
    }
  }
}
export default Header;